export default __webpack_public_path__ + "static/media/SeltosGallery6.794bcd05.jpg";